import { render, staticRenderFns } from "./WorkingHours.vue?vue&type=template&id=6153137e"
import script from "./WorkingHours.vue?vue&type=script&lang=ts"
export * from "./WorkingHours.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports